import * as Dates from '../Dates';

export default class HourlyForecastItem {
  timezone: string;
  data: Record<string, any>;

  constructor(timezone: string, data: Record<string, any>) {
    this.timezone = timezone;
    this.data = data;
  }

  getDatetime() {
    return Dates.timezoneDateFromTimestamp(this.getTimestamp(), this.timezone);
  }

  getTimestamp(): number {
    return this.data.timestamp;
  }

  formatTime(formatter: string) {
    return Dates.formatDate(this.getTimestamp(), this.timezone, formatter);
  }

  getWindAngle() {
    return this.data.DD;
  }

  getWindSpeed() {
    return this.data.FF;
  }

  getWindGust() {
    return this.data.FXY;
  }

  getTemp() {
    return this.data.T;
  }

  getRain() {
    return this.data.RR;
  }

  getSnow() {
    return this.data.SN;
  }

  getPressure() {
    return this.data.SLP;
  }

  getHumidity() {
    return this.data.U;
  }

  getIcon() {
    return this.data.ICON;
  }
}
